import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { useAlert } from '../context/AlertContext';
import { ILegalClient } from '../Interfaces/ILegalClient';

interface IProps {
  clients: ILegalClient[];
  onAddCustomId: (legalClientId: number, customId: string) => void;
  onClose: () => void;
}

export const AddCustomIdDialog = ({
  clients,
  onAddCustomId,
  onClose,
}: IProps) => {
  const { showAlert } = useAlert();
  const [selectedClient, setSelectedClient] = useState<ILegalClient>();
  const [customId, setCustomId] = useState<string>('');

  const handleSave = () => {
    if (selectedClient && customId) {
      onAddCustomId(selectedClient.idLegalClient, customId);
    } else {
      showAlert({
        text: 'Bitte wählen Sie einen Mandanten und geben Sie eine Kennung ein.',
        severity: 'error',
      });
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Mandantenkennung hinzufügen</DialogTitle>
      <DialogContent>
        <TextField
          label='Kontakt'
          sx={{ mt: 1 }}
          value={selectedClient?.idLegalClient}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setSelectedClient(
              clients.find(
                c => c.idLegalClient === Number(event.target.value)
              ) ?? undefined
            )
          }
          fullWidth
          select
        >
          {clients.map((c, i) => (
            <MenuItem key={i} value={c.idLegalClient}>
              {c.FirstName ?? ''} {c.LastName ?? ''}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          value={customId}
          onChange={e => setCustomId(e.target.value)}
          label='Mandantenkennung'
          variant='outlined'
          fullWidth
          margin='normal'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button variant='contained' onClick={handleSave}>
          Hinzufügen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
